export default __webpack_public_path__ + "static/media/renault.38d3c2db.jpg";